import React from 'react';

interface SquirrelLogoProps {
  shape?: 'circle' | 'square' | 'rounded';
  size?: number;
}

const SquirrelLogo: React.FC<SquirrelLogoProps> = ({
  shape = 'rounded',
  size = 36
}) => {
  const getBorderRadius = () => {
    switch(shape) {
      case 'circle': return '50%';
      case 'square': return '4px';
      case 'rounded': return '8px';
      default: return '8px';
    }
  };

  return (
    <div style={{
      width: `${size}px`,
      height: `${size}px`,
      background: 'white',
      borderRadius: getBorderRadius(),
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
      fontSize: `${size * 0.67}px`,
      transition: 'all 0.3s',
      marginTop: '-2px'
    }}>
      🐿️
    </div>
  );
};

export default SquirrelLogo;
